import { render, staticRenderFns } from "./index.vue?vue&type=template&id=27c12e1c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=27c12e1c&prod&lang=less&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=27c12e1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_17bc9983cdb7459b16429e97d92f86dc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c12e1c",
  null
  
)

export default component.exports